import { render, staticRenderFns } from "./dists.vue?vue&type=template&id=b83ee8b6"
import script from "./dists.vue?vue&type=script&lang=js"
export * from "./dists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports